import { FC } from 'react';

type ChambersFillnessIconProps = {
    color?: 'red' | 'amber' | 'yellow' | 'green';
    width?: number;
    height?: number;
    className?: string;
};

export const ChambersFillnessIcon: FC<ChambersFillnessIconProps> = ({ color, height = 18, width = 14, className }) => {
    if (!color || color === 'red') {
        return (
            <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.277102 0.244652C0.138732 0.400331 0.0733873 0.607643 0.0977942 0.814469L1.67675 14.2435V14.2444L2.04266 17.356C2.08574 17.7233 2.397 18.0001 2.76689 18.0001H11.2326C11.6025 18.0001 11.9137 17.7233 11.9568 17.356L12.3227 14.2444V14.2435L13.9016 0.814469C13.926 0.607643 13.8606 0.400233 13.7223 0.244652C13.5839 0.0890704 13.3855 0 13.1773 0H0.822123C0.613838 0 0.415472 0.0890704 0.277102 0.244652ZM10.584 16.5414H3.41547L3.22236 14.8985H10.7771L10.584 16.5414ZM12.3572 1.45858L10.9486 13.4399H3.05083L1.64213 1.45858H12.3572Z"
                    fill="#FF4863"
                />
            </svg>
        );
    }

    if (color === 'amber') {
        return (
            <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.277102 0.244652C0.138732 0.400331 0.0733873 0.607643 0.0977942 0.814469L1.67675 14.2435L2.04266 17.356C2.08574 17.7233 2.397 18.0001 2.76689 18.0001H11.2326C11.6025 18.0001 11.9137 17.7233 11.9568 17.356L12.3227 14.2444L13.9016 0.814469C13.926 0.607643 13.8606 0.400233 13.7223 0.244652C13.5839 0.0890704 13.3855 0 13.1773 0H0.822123C0.613838 0 0.415472 0.0890704 0.277102 0.244652ZM10.584 16.5414H3.41547L3.22236 14.8985H10.7771L10.584 16.5414ZM12.3572 1.45858L11.2326 9.6H2.76689L1.64213 1.45858H12.3572Z"
                    fill="#FF9500"
                />
            </svg>
        );
    }

    if (color === 'yellow') {
        return (
            <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.277102 0.244652C0.138732 0.400331 0.0733873 0.607643 0.0977942 0.814469L1.67675 14.2435L2.04266 17.356C2.08574 17.7233 2.397 18.0001 2.76689 18.0001H11.2326C11.6025 18.0001 11.9137 17.7233 11.9568 17.356L12.3227 14.2444L13.9016 0.814469C13.926 0.607643 13.8606 0.400233 13.7223 0.244652C13.5839 0.0890704 13.3855 0 13.1773 0H0.822123C0.613838 0 0.415472 0.0890704 0.277102 0.244652ZM10.584 16.5414H3.41547L3.22236 14.8985H10.7771L10.584 16.5414ZM12.3572 1.45858L11.9568 5.4L2.04266 5.4L1.64213 1.45858H12.3572Z"
                    fill="#FFD900"
                />
            </svg>
        );
    }

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.277102 0.244652C0.138732 0.400331 0.0733873 0.607643 0.0977942 0.814469L1.67675 14.2435L2.04266 17.356C2.08574 17.7233 2.397 18.0001 2.76689 18.0001H11.2326C11.6025 18.0001 11.9137 17.7233 11.9568 17.356L12.3227 14.2444L13.9016 0.814469C13.926 0.607643 13.8606 0.400233 13.7223 0.244652C13.5839 0.0890704 13.3855 0 13.1773 0H0.822123C0.613838 0 0.415472 0.0890704 0.277102 0.244652ZM10.584 16.5414H3.41547L3.22236 14.8985H10.7771L10.584 16.5414ZM12.3572 1.45858L11.9568 3L2.04266 3L1.64213 1.45858H12.3572Z"
                fill="#00E58E"
            />
        </svg>
    );
};
